// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}

.loading-spinner::after {
  content: '';
  width: 50px;
  height: 50px;
  border: 5px solid var(--background-color);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spinner 1s ease-in-out infinite;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

/*
 * Inline loading spinner, for a panel inside a page rather than a whole route.
 *
 * Deliberately NOT named \`.loading-spinner\`: that name is defined four times
 * across this codebase with conflicting rules (above, teams-list.css,
 * action-log.css, KnowledgeGraphViewer.css), so which one applies depends on
 * CSS import order. These names have exactly one definition.
 *
 * These replace \`animate-spin rounded-full h-12 w-12 border-b-2
 * border-blue-500\` — a Tailwind utility string in a project that has no
 * Tailwind. Every one of those classes resolved to nothing, so the element was
 * an empty unstyled div and roughly fifteen screens showed a blank area while
 * they loaded.
 */
.spinner-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  /* was \`h-64\` */
  min-height: 16rem;
}

.spinner-inline {
  /* was \`h-12 w-12\` */
  width: 48px;
  height: 48px;
  margin: 0 auto;
  border-radius: 50%;
  /* was \`border-b-2 border-blue-500\` */
  border-bottom: 2px solid var(--link-color);
  animation: spinner 1s linear infinite;
}

/* was \`h-8 w-8\` */
.spinner-inline.spinner-small {
  width: 32px;
  height: 32px;
}

/* An icon component that spins in place, rather than a bare div. */
.spin-icon {
  animation: spinner 1s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./src/loading-spinner.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,sCAAsC;EACtC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;;;;;;;;;;EAaE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mEAAmE;AACnE;EACE,qCAAqC;AACvC","sourcesContent":[".loading-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100%;\n}\n\n.loading-spinner::after {\n  content: '';\n  width: 50px;\n  height: 50px;\n  border: 5px solid var(--background-color);\n  border-top-color: var(--primary-color);\n  border-radius: 50%;\n  animation: spinner 1s ease-in-out infinite;\n}\n\n@keyframes spinner {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/*\n * Inline loading spinner, for a panel inside a page rather than a whole route.\n *\n * Deliberately NOT named `.loading-spinner`: that name is defined four times\n * across this codebase with conflicting rules (above, teams-list.css,\n * action-log.css, KnowledgeGraphViewer.css), so which one applies depends on\n * CSS import order. These names have exactly one definition.\n *\n * These replace `animate-spin rounded-full h-12 w-12 border-b-2\n * border-blue-500` — a Tailwind utility string in a project that has no\n * Tailwind. Every one of those classes resolved to nothing, so the element was\n * an empty unstyled div and roughly fifteen screens showed a blank area while\n * they loaded.\n */\n.spinner-panel {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* was `h-64` */\n  min-height: 16rem;\n}\n\n.spinner-inline {\n  /* was `h-12 w-12` */\n  width: 48px;\n  height: 48px;\n  margin: 0 auto;\n  border-radius: 50%;\n  /* was `border-b-2 border-blue-500` */\n  border-bottom: 2px solid var(--link-color);\n  animation: spinner 1s linear infinite;\n}\n\n/* was `h-8 w-8` */\n.spinner-inline.spinner-small {\n  width: 32px;\n  height: 32px;\n}\n\n/* An icon component that spins in place, rather than a bare div. */\n.spin-icon {\n  animation: spinner 1s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
